import { render } from "./DetailOrder.vue?vue&type=template&id=0e29d1e6"
import script from "./DetailOrder.vue?vue&type=script&lang=js"
export * from "./DetailOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__